import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import FileUploaderMultiple from "./common/FileUploaderMultiple";
import ReactQuill from "react-quill";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { db, storage } from "../firebaseConfig";
import { toast } from "react-toastify";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { postShoppingHistory } from "./common/History/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewShelfPackage,
  getShelfPackages,
  getShelfShoppingPackages,
  updateItemDetails,
  updateShelfPackageDetails,
  updateShelfShoppingPackageDetails,
} from "../helper/functions";
import { newShelfPackage } from "../helper";
import { setPackages } from "../store/commonSlice";

const postShoppingStatusConveter = (status) => {
  if (status === "Placed order") {
    return "Ordered";
  } else if (status === "Update tracking number") {
    return "Received";
  } else {
    return "";
  }
};

const initialValues = {
  postShopping: {
    // postShoppingStatus: "",
    // orderNumber: "",
    // tracingNumber: "",
    // orderReceivedImage: "",
    // wrongItemNotes: "",
    // wrongAddressNotes: "",
    postShoppingStatus: "",
    time: "",
    orderNumber: "",
    tracking: "",
  },
};

export default function PostShopping({
  itemsData,
  packageActiveData,
  userActiveData,
  pageName,
  packageCollection = "shelfPackages",
}) {
  const dispatch = useDispatch();
  const [initialValue, setInitialValue] = useState(initialValues);
  const [orderReceivedImage, setOrderReceivedImage] = useState(null);
  const [wrongItemNotes, setWrongItemNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.auth.value);
  // console.log(user, "user in post shopping");
  // console.log(itemsData, "itemsData");
  console.log(itemsData, "itemsData in post shopping");

  useEffect(() => {
    if (itemsData) {
      setInitialValue({
        postShopping: {
          postShoppingStatus: itemsData?.postShopping?.postShoppingStatus || "",
          orderNumber: itemsData?.postShopping?.orderNumber || "",
          trackingNumber: itemsData?.postShopping?.trackingNumber || "",
        },
      });
      // setWrongItemNotes(itemsData.postShopping?.wrongItemNotes || "");
      // setOrderReceivedImage(itemsData.postShopping?.orderReceivedImage || "");
    }
  }, [itemsData]);

  const formik = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    onSubmit: async (value) => {
      console.log(value, "value");
      setLoading(true);
      try {
        const { postShoppingStatus, orderNumber, trackingNumber } =
          value.postShopping;
          const selectedItem = packageActiveData?.itemDetails?.find((item) => item?.itemId === itemsData?.id);
          console.log(postShoppingStatus,selectedItem,"dssffdsdsgd")
        const packageStatus = postShoppingStatusConveter(postShoppingStatus);
        if (
          postShoppingStatus === "Update tracking number" &&
          selectedItem?.itemStatus === "PENDING"
        ) {
          toast.error("First place the order !");
          return null;
        }
        const packageData = {
          itemDetails: packageActiveData?.itemDetails?.map((item) => item?.itemId === itemsData?.id ? { ...item, orderNumber: postShoppingStatus === "Placed order" ? orderNumber : item?.orderNumber , itemStatus:postShoppingStatus === "Placed order"? "ORDERED": postShoppingStatus === "Update tracking number" ? "COMPLETED" : item?.itemStatus , orderedAt: postShoppingStatus === "Placed order" ? new Date() : item?.orderedAt, trackingNumber: postShoppingStatus === "Update tracking number" ? trackingNumber : item?.trackingNumber, receivedAt: postShoppingStatus === "Update tracking number" ?  new Date() : item?.receivedAt } : item),
        };
        console.log(packageData, packageCollection, packageActiveData, "packageCollection123456");

        const updatedData = await updateShelfShoppingPackageDetails(
          packageActiveData?.id,
          packageData
        );
        // console.log(updatedData, "updatedDatattttata");
        postShoppingHistory(
          dispatch,
          itemsData,
          value.postShopping,
          user?.name,
          packageActiveData,
          packageCollection
        );
        updateItemDetails(itemsData?.id, {
          postShopping: {
            postShoppingStatus: postShoppingStatus || "",
            date:
              postShoppingStatus === "Update tracking number" ||
                postShoppingStatus === "Order delivered damaged"
                ? serverTimestamp()
                : "",
            orderNumber: orderNumber || "",
            trackingNumber: trackingNumber || "",
            wrongItemNotes: wrongItemNotes || "",
            // orderReceivedImage: photoUrl1 ? photoUrl1 : "",
          },
          preShoppingStatus:
            postShoppingStatus === "Return by Admin" ||
              postShoppingStatus === "Customer requested return"
              ? "Cancel Item"
              : "",
        }).then(() => {
          toast.success("Post Shopping Status Updated Successfully !");
          setLoading(false);
        }).catch(() => {
          setLoading(false)
        });
        if (postShoppingStatus === "Update tracking number") {
          const shelfPackages = await getShelfPackages([
            {
              key: "trackingNumber",
              operator: "==",
              value: trackingNumber,
            },
          ]);
          if (shelfPackages?.length > 0) {
            const packageDetails = shelfPackages[0];
            if (!packageDetails?.packageItemIds?.includes(itemsData?.id)) {
              const updatedPackage = await updateShelfPackageDetails(
                packageDetails.id,
                {
                  packageImages: [
                    ...packageDetails?.packageImages,
                    itemsData?.itemImageURL,
                  ],
                  packageItemIds: [
                    ...packageDetails?.packageItemIds,
                    itemsData?.id,
                  ],
                  packageTotalAmount:
                    packageDetails?.packageTotalAmount +
                    itemsData?.price * itemsData?.quantity,
                  packageTotalWeight:
                    packageDetails?.packageTotalWeight +
                    itemsData?.weight * itemsData?.quantity,
                }
              );
            }
          } else {
            addNewShelfPackage(
              newShelfPackage(packageActiveData, itemsData, trackingNumber)
            ).then(() => {
              setLoading(false);
            }).catch(() => {
              setLoading(false);
            });
          }

          // const shelfPackage = await getShelfShoppingPackages([
          //   {
          //     key: "mySuiteId",
          //     operator: "==",
          //     value: userActiveData?.id,
          //   },
          //   {
          //     key: "isShoppingRequestCompleted",
          //     operator: "==",
          //     value: false,
          //   },
          // ]);
          // setLoading(false);
          // dispatch(setPackages(shelfPackage))
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    },
  });

  // console.log(formik.values, "formik.values");

  return (
    <Box sx={{ marginLeft: "10px" }}>
      <Box sx={{ display: "grid", marginTop: "10px" }}>
        <label style={{ fontWeight: "bold", fontSize: "14px" }}>Select</label>
        <form onSubmit={formik.handleSubmit}>
          <Box>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="postShopping.postShoppingStatus"
                onChange={formik.handleChange}
                value={formik.values.postShopping.postShoppingStatus}
              >
                <FormControlLabel
                  value="Placed order"
                  control={<Radio />}
                  disabled={pageName === "shippingComplete"}
                  label="Placed order"
                />
                <FormControlLabel
                  value="Update tracking number"
                  control={<Radio />}
                  disabled={pageName === "shippingComplete"}
                  label="Update tracking number"
                />
                <FormControlLabel
                  value="Wrong item delivered"
                  control={<Radio />}
                  disabled={pageName === "shippingComplete"}
                  label="Wrong item delivered"
                />
                <FormControlLabel
                  value="Order delivered in wrong address"
                  control={<Radio />}
                  disabled={pageName === "shippingComplete"}
                  label="Order delivered in wrong address"
                />
                <FormControlLabel
                  value="Return by Admin"
                  control={<Radio />}
                  disabled={pageName === "shippingComplete"}
                  label="Return by Admin"
                />
                <FormControlLabel
                  value="Customer requested return"
                  control={<Radio />}
                  disabled={pageName === "shippingComplete"}
                  label="Customer requested return"
                />
              </RadioGroup>
            </FormControl>
          </Box>

          {formik.values.postShopping.postShoppingStatus === "Placed order" && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                mt: 2,
              }}
            >
              <label
                style={{
                  fontSize: "16px",
                  fontWeight: "normal",
                  marginBottom: "5px",
                }}
              >
                Enter order number
              </label>
              <FormControl sx={{}} size="small">
                <OutlinedInput
                  type="text"
                  id="placeOrder"
                  placeholder="Enter last 5 digit of order no."
                  name="postShopping.orderNumber"
                  value={formik.values.postShopping.orderNumber}
                  onChange={formik.handleChange}
                  disabled={pageName === "shippingComplete"}
                />
              </FormControl>
            </Box>
          )}

          {formik.values.postShopping.postShoppingStatus ===
            "Update tracking number" && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  mt: 2,
                }}
              >
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    marginBottom: "5px",
                  }}
                >
                  Enter tracking number
                </label>
                <FormControl size="small">
                  <OutlinedInput
                    type="text"
                    id="orderReceived"
                    placeholder="Enter tracking number"
                    name="postShopping.trackingNumber"
                    value={formik.values.postShopping.trackingNumber}
                    onChange={formik.handleChange}
                    disabled={
                      pageName === "shippingComplete" ||
                      itemsData?.postShopping?.trackingNumber
                    }
                  />
                </FormControl>
              </Box>
            )}

          {(formik.values.postShopping.postShoppingStatus ===
            "Wrong item delivered" ||
            formik.values.postShopping.postShoppingStatus ===
            "Order delivered in wrong address") && (
              <Box>
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    marginBottom: "5px",
                    marginTop: "10px",
                    display: "block",
                  }}
                >
                  Notes
                </label>
                <Box>
                  <ReactQuill
                    theme="snow"
                    value={wrongItemNotes}
                    onChange={setWrongItemNotes}
                    disabled={pageName === "shippingComplete"}
                  />
                </Box>
              </Box>
            )}

          <Box>
            <Button
              variant="contained"
              type="submit"
              // onClick={statusChangeHandler}
              // disabled={
              //   loading
              //   // orderactiveData?.status === "SHIP READY" ||
              //   // orderactiveData?.status === "ENROUTE" ||
              //   // orderactiveData?.status === "CLOSED" ||
              //   // orderactiveData?.status === "CANCELED"
              // }
              disabled={pageName === "shippingComplete"}
              sx={{
                width: "200px",
                marginTop: "20px",
                borderRadius: "4px",
              }}
            >
              Update Status
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
}
